import { render, staticRenderFns } from "./Downloads.vue?vue&type=template&id=68e6b7ea"
import script from "./Downloads.vue?vue&type=script&lang=ts"
export * from "./Downloads.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports